import { WEB_URL } from "@/config/endpoints"
import IMAGES from "@/public/assets/img";


export default {
  SeoContent:{
        title: 'Calculadora de la Mejor Tasa de Interés para el Financiamiento de Comercio de Exportación',
        url:  WEB_URL+'/es-mx/interest-calculator',
        name:'description',
        description:'Ofrecemos las tasas de interés más bajas para su comercio de factoring de exportación sin tarifa de factoring. Calcule la tasa de interés y obtenga el mejor precio para el financiamiento de facturas.',
        keyword: 'Financiamiento de la cadena de suministro, financiamiento de la cadena de suministro en India, cadena de suministro en finanzas, empresa de financiamiento de la cadena de suministro, las tasas de interés más bajas para su factoring de exportación, calcule la tasa de interés.', 
        imagePath:IMAGES.HOMEIMG.bigLogoNew.src
    },
    CalcIndia:false,
    Calc:{
      leftHeading:'El mejor precio para <br className="sm:hidden md:hidden xm:hidden"/> Financiamiento de exportaciones',
      whyCalculate:[
        "Tarifa de factoraje <strong> más baja </strong>",
        "<strong> Hasta 90% </strong> de desembolso",
        "Desembolso <strong>rápido</strong>"
      ],
      heading2:'Calcular el costo por factura',
      principalAmt:'Monto de la factura (en $)',
      tenor:'Tenor (En días)',
      rightHeading:'De más rápido crecimiento y una de las empresas de factoraje de exportación más grandes de México.',
      competitionHead:'Competencia',
      totAmt:'Monto de la factura',
      fundAmt:'Monto de financiamiento (80% de financiamiento)',
      factorText:'Tarifa de factoraje/por mes @',
      edit:'Editar',
      applicable:'(Aplicable al monto de financiación, es decir, 80%)',
      totalText:'Tarifas totales',
      fundAmtCredlix:'Monto de financiamiento (90% de financiamiento)',
      applicableCred:'(Aplicado sobre el monto de financiamiento real, es decir, 90%)',
      annAmt:'Ahorro anual',
      note:'Nuestra promesa: en caso de que obtenga un mejor precio, lo igualaremos.',
      ctaName:'Empezar ahora',
      days:'días',
    }
}